import { render } from "./NewMenuComponent.vue?vue&type=template&id=608df314&scoped=true"
import script from "./NewMenuComponent.vue?vue&type=script&lang=js"
export * from "./NewMenuComponent.vue?vue&type=script&lang=js"

import "./NewMenuComponent.vue?vue&type=style&index=0&id=608df314&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608df314"]])

export default __exports__